/**
 * The three operator lenses that survive the project-scoped IA. None is a
 * route: each is mounted by id inside a project tab — Active Work in Work,
 * the Frontier lens and Architecture Pressure in Insights.
 */
export type LensId = "work" | "frontier" | "architecture";
export type LensSpec = {
  id: LensId;
  title: string;
  eyebrow: string;
  question: string;
  reference: string;
  views: readonly string[];
};

export const LENSES: readonly LensSpec[] = [
  {
    id: "frontier",
    title: "Frontier Lens",
    eyebrow: "FRONTIERS / LENS",
    question: "Explore concurrent Heads and the certified transitions connecting them.",
    reference: "20-frontier-lens.png",
    views: ["Frontier", "Manifold", "Timeline"],
  },
  {
    id: "work",
    title: "Active Work",
    eyebrow: "ACTIVE WORK",
    question: "Follow agent Work from intent through findings and evidence.",
    reference: "21-active-work.png",
    views: ["Graph", "Queue", "Agents"],
  },
  {
    id: "architecture",
    title: "Architecture Pressure",
    eyebrow: "ARCHITECTURE / PRESSURE",
    question: "Where do observed dependencies concentrate?",
    reference: "29-architecture-pressure.png",
    views: ["Graph", "Hotspots", "Layers"],
  },
];

/** The lens a project tab mounts. Every id names exactly one entry. */
export function lensById(id: LensId): LensSpec {
  const spec = LENSES.find((lens) => lens.id === id);
  if (!spec) throw new Error(`Lens ${id} is missing from the catalog`);
  return spec;
}
